<template>
  <div>
    <div>
      <div class="form-cell">
        <label>{{ $t('general.name') }}</label>
        <BFormInput
          v-model="name"
          :placeholder="$t('general.name')"
        />
      </div>
      <!-- <div class="form-cell">
        <label>{{ $t('general.code') }}</label>
        <BFormInput
          v-model="code"
          :placeholder="$t('general.code')"
        />
      </div> -->
      <div class="form-cell">
        <label>{{ $t('general.description') }}</label>
        <BFormTextarea
          v-model="description"
          :placeholder="$t('general.description')"
        />
      </div>
      <!-- <hr>
      <div
        class="row"
        style="width: 400px; margin-left: auto; margin-right: 0"
      >
        <div class="col-6">
          <button
            class="btn btn-secondary btn-block btn-sm"
            @click="$emit('close')"
          >
            <i class="fas fa-times pr-2" />
            {{ $t('general.cancel') }}
          </button>
        </div>
        <div class="col-6">
          <button
            data-test="save-client-details-button"
            class="btn btn-primary btn-block btn-sm"
            :disabled="pending"
            @click="submit"
          >
            <i class="fas fa-check pr-2" />
            {{ $t('general.save') }}
          </button>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    product: Object,
    catalogId: String,
  },
  data: () => ({
    name: '',
    description: '',
    pending: false,
  }),
  methods: {
    ...mapActions('shop', [
      'addProduct',
      'updateProduct',
      'removeProduct',
    ]),
    remove() {
      this.pending = true;
      this.removeProduct({
        params: {
          productId: this.product.id,
          catalogId: this.catalogId,
        },
      })
        .then(() => {
          this.$emit('close');
          this.$emit('refresh');
        })
        .finally(() => {
          this.pending = false;
        });
    },
    sendUpdate() {
      if (this.product) {
        return this.updateProduct({
          params: {
            productId: this.product.id,
            catalogId: this.catalogId,
          },
          data: {
            name: this.name,
            description: this.description,
          },
        });
      }
      return this.addProduct({
        params: {
          catalogId: this.catalogId,
        },
        data: {
          name: this.name,
          description: this.description,
        },
      });
    },
    submit() {
      this.pending = true;
      this.sendUpdate()
        .then(() => {
          this.$emit('close');
          this.$emit('refresh');
        })
        .finally(() => {
          this.pending = false;
        });
    },
  },
  created() {
    if (this.product) {
      this.name = this.product.name;
      this.description = this.product.description;
    }
  },
};
</script>

<style lang="scss" scoped>
.form-cell {
  padding: 5px;
}

.product-remove {
  border-radius: 50%;
  width: 35px;
  height: 35px;
  font-size: 18px;
  line-height: 35px;
  margin-left: 5px;
  cursor: pointer;
  text-align: center;

  &:hover {
    background-color: rgba(#333, 0.2);
  }
}
</style>
